export const environment = {
  apiUrl: 'https://dev-oc-touchpoint-kiosk-api.azurewebsites.net',
  apiOcCobraUrl: 'https://dev-occobra.azurewebsites.net',
  apiCobraUrl: 'https://dev-c-api.reward-access.com',
  externalId: '11000001',
  deviceHash: 'nAYQ5WVA28Wl6IeZgdaI/EybNm/1JDaiPFKNhhngiSY=',
  kioskToken: 'aUn_Bh56VUa64v3qziz5CA',
  instrumentationKey: '27737840-76d6-4c8c-935d-760a95a04d1f'
};
